module.exports = __webpack_public_path__ + "img/UTGUNL-4.b7523745.jpg";